'use strict'
/**
 * GeolocationMixin
 * [概要]
 *   GeolocationAPIを使用して位置情報を取得し、結果を返却します。
 *   位置情報は非同期で取得するため、Promiseにて取得状況を制御し、一定秒数内に結果が取得できなければエラーを返却します。
 */

import { appconfig } from '../lib/appconfig.js'
import { langData } from '../lib/lang/index.js'

/**
 * getGeolocation
 */
export default {
  data () {
    return {
      watchID: null,
      lat: null,
      lng: null,
      permission: 0, // 0=待機,1=許可要求中,2=許可,9=不許可
      timer: null,
      rejectReason: null
    }
  },
  methods: {
    /**
     * success
     * @param Object position GeolocationAPIから取得した位置情報
     */
    success (position) {
      this.lat = position.coords.latitude
      this.lng = position.coords.longitude
      this.permission = 2
    },
    /**
     * error
     * @param Object error GeolocationAPIが返却したエラー情報
     */
    error (error) {
      console.error(error)
      switch (error.code) {
        case 1:
          // 位置情報の利用不許可
          this.rejectReason = langData[sessionStorage.getItem('lang')].ErrorMsg.ERR_002
          break
        case 2:
          // 位置の判定ができない
          this.rejectReason = langData[sessionStorage.getItem('lang')].ErrorMsg.ERR_003
          break
        case 3:
          // タイムアウト
          this.rejectReason = langData[sessionStorage.getItem('lang')].ErrorMsg.ERR_004
          break
      }
      this.permission = 9
      window.commonAlert(this.rejectReason)
    },
    getGeolocation () {
      // GeolocationAPIに未対応の場合
      if (!('geolocation' in navigator)) {
        window.commonAlert(langData[sessionStorage.getItem('lang')].ErrorMsg.ERR_001)
        return
      }

      // 初期化
      this.watchID = null
      this.permission = 0
      this.rejectReason = null

      return new Promise((resolve, reject) => {
        this.watchID = navigator.geolocation.watchPosition(this.success, this.error, appconfig.geolocation.options)
        this.timer = setInterval(() => {
          // GeolocationAPIの利用許可要求が解決するまでは処理をしない
          if (this.permission === 9) {
            navigator.geolocation.clearWatch(this.watchID) // 位置情報の監視を終了
            // 位置情報利用不可
            this.lat = null
            this.lng = null
            clearInterval(this.timer)
            reject(new Error(this.rejectReason))
          } else if (this.permission === 2) {
            // 位置情報利用可能
            navigator.geolocation.clearWatch(this.watchID) // 位置情報の監視を終了
            clearInterval(this.timer)
            resolve({
              lat: this.lat,
              lng: this.lng
            })
          }
        }, 1000)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GeolocationMixin.js